import { memo } from "react";
import { ReloadIcon } from "@/icons";
import { Tooltip } from "@/interface/ui/Tooltip";
import styles from "../FullscreenPresentationLayout.module.scss";

type ReloadControlProps = {
    onReload: () => void;
};

export const ReloadControl = memo(({ onReload }: ReloadControlProps) => {
    return (
        <div className={styles.reloadControl}>
            <Tooltip content="Перезагрузить">
                <button className={styles.navigationButton} type="button" onClick={onReload}>
                    <ReloadIcon />
                </button>
            </Tooltip>
        </div>
    );
});
